// extracted by mini-css-extract-plugin
module.exports = {"Messages":"Messages_Messages__2Y2Xo"};